module.exports = __webpack_public_path__ + "h5/img/serve.a630667f.png";